import {Component, Input, OnInit} from '@angular/core';
import {TimelineModel} from '../../../shared/models/timeline.model';

@Component({
	selector: 'app-kamona-timeline',
	templateUrl: './kamona-timeline.component.html',
	styleUrls: ['./kamona-timeline.component.scss']
})
export class KamonaTimelineComponent implements OnInit {
	@Input() steps: TimelineModel [] = [];
	@Input() stepperBottom: boolean;

	constructor() {
	}

	ngOnInit(): void {
	}

}
